import { Box, Chip, Typography } from '@mui/material'
import "@fontsource/rubik";
import useCustomTheme from '../../../theme/useCustomTheme'
import { formatHistoryDate } from '../../../utils/revisionHistory'
import { contentCountLabel } from '../../../utils/revisionContent'

/**
 * One row in the version list. Badges are rendered straight from the response
 * flags - the backend does not guarantee exactly one `latest` or `accepted`
 * version, so each flag is rendered independently rather than derived.
 */
const RevisionHistoryVersionCard = (props) => {
  const { version, selected, onClick } = props;
  const [theme] = useCustomTheme()

  return (
    <Box
      data-testid='revision-history-version-card'
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        padding: { xs: '8px', lg: '10px', xl: '14px' },
        borderRadius: '8px',
        marginBottom: '8px',
        backgroundColor: selected ? '#08231B' : '#ffffff',
        color: selected ? '#ffffff' : '#08231B',
        boxShadow: '0px 3px 8px #00000014',
        border: selected ? `1px solid ${theme.palette.primary.main}` : '1px solid transparent',
      }}
    >
      <Typography
        sx={{ fontFamily: 'Rubik', fontWeight: 600, fontSize: { xs: '9px', md: '11px', lg: '12px', xl: '16px' } }}
      >
        Version {version?.version}
      </Typography>

      <Typography
        sx={{ fontFamily: 'Rubik', opacity: 0.75, fontSize: { xs: '7px', md: '9px', lg: '9px', xl: '12px' }, mt: 0.2 }}
      >
        {formatHistoryDate(version?.delivered_at)}
      </Typography>

      {/* `revision` is null on a version nobody asked changes on, and a revision
          with no files still returns all five keys as zeros - so a count is
          shown only where there is actually a revision to count for. */}
      {!!version?.revision?.content_counts && Number(version.revision.content_counts.total) > 0 && (
        <Typography
          data-testid='revision-history-file-count'
          sx={{ fontFamily: 'Rubik', opacity: 0.75, fontSize: { xs: '7px', md: '9px', lg: '9px', xl: '12px' }, mt: 0.2 }}
        >
          {contentCountLabel(version.revision.content_counts)}
        </Typography>
      )}

      <Box className='flex' gap={0.5} sx={{ flexWrap: 'wrap', mt: 0.6 }}>
        {version?.latest === true && <HistoryBadge label='Latest' />}
        {version?.accepted === true && <HistoryBadge label='Accepted' />}
        {version?.sent_for_approval === true && <HistoryBadge label='Sent for approval' />}
      </Box>
    </Box>
  )
}

const HistoryBadge = ({ label }) => (
  <Chip
    label={label}
    size='small'
    data-testid={`revision-history-badge-${label}`}
    sx={{
      height: { xs: '13px', lg: '16px', xl: '22px' },
      backgroundColor: '#e8f5ee',
      color: '#08231B',
      fontFamily: 'Rubik',
      fontWeight: 600,
      fontSize: { xs: '6px', md: '7px', lg: '8px', xl: '11px' },
    }}
  />
)

export default RevisionHistoryVersionCard
